import { DEFAULT_COLORS } from '@components/widgets/apacheEchart/Commons'
import { getCommonWidget } from '../../dashWidgetHelper'
import { commonWidgets, msurPorcRespuestasMapper, msurTooltipTotalRegistros } from '../commonWidgetsMedicasur'
import { formatLabelsObject } from '../../../../../utils/labelFormatter.util';
import { renderForCriticalMoment } from '../../dashHelper'


const GROUP_LABELS_PERSONAL = {
    'exp_hosp_enfermeria_trato': 'Enfermeria',
    'exp_hosp_medico_trato': 'Médicos',
    'exp_hosp_admision_trato': 'Admisión',
    'exp_hosp_camilleros_trato': 'Camilleros',
    'exp_hosp_instalaciones_calidad': 'Instalaciones',
    'exp_hosp_nutricion_informacion': 'Nutricion',
    'exp_hosp_paciente_estadia': 'Servicios a Pacientes',
}

const GROUP_LABELS_ADMISION = {
    'exp_hosp_admision_trato': 'Trato y Claridad de la información',
    'exp_hosp_admision_espera': 'Agilidad del registro',
    //'exp_hosp_seguros_egreso': 'Agilidad y atención del alta',
    //'exp_hosp_admision_trato': 'Claridad de la información'
}

const GROUP_LABELS_ENFERMERIA = {
    'exp_hosp_enfermeria_trato': 'Trato',
    //'serv_cidyt_enfermeria_privacidad': 'Privacidad, seguridad y respeto',
    'exp_hosp_medico_atencion': 'Atención oportuna'
}

const GROUP_LABELS_PERSONAL_MEDICO = {
    'exp_hosp_medico_trato': 'Trato',
    //'exp_hosp_inf_y_ate_privacidad': 'Privacidad, seguridad y respeto',
    //'serv_clin_prof_explicacion': 'Claridad en la información',
    //'exp_hosp_inf_y_ate_consideraciones': 'Lo toma en cuenta',
    'exp_hosp_medico_atencion': 'Atención oportuna'
}

//commented original definition to const GROUP_LABELS_NUTRICION
//and re defined it to add new property
/*
const GROUP_LABELS_NUTRICION = {
    //'': 'Atención por la nutrióloga',
    'exp_hosp_nutricion_sabor': 'Temperatura y presentación de los alimentos',
    'exp_hosp_nutricion_informacion': 'Información sobre dieta'
}*/

const GROUP_LABELS_NUTRICION = {
  'exp_hosp_nutricion_sabor': 'Sabor y presentación',
  'exp_hosp_nutricion_informacion': 'Información sobre dieta',
  'exp_hosp_nutricion_temperatura': 'Temperatura de los alimentos'
}

const GROUP_LABELS_CAMILLERO = {
    'exp_hosp_camilleros_trato': 'Trato y Tiempo de espera'
}

const GROUP_LABELS_PACIENTES_Y_FAMILIARES = {
    'exp_hosp_paciente_estadia': 'Trato, apoyo y tiempo de respuesta',
    //'': 'Explicación clara',
    'exp_hosp_paciente_informacion': 'Información clara'
}

const GROUP_LABELS_INSTALACIONES = {
    'exp_hosp_instalaciones_calidad': 'Calidad en general de las instalaciones',
    //'': 'Calidad de las habitaciones',
    //'serv_cidyt_instalacion_calidad': 'Calidad y Confort del inmobiliario'
}

const GROUP_LABELS_LIMPIEZA = {
    'exp_hosp_instalaciones_limpieza': 'Limpieza de las instalaciones',
    //'': 'Limpieza de las habitaciones',
    //'serv_cidyt_instalacion_limpieza_consultorio': 'Limpieza de las consultorios'
}


export default {
    title: 'Experiencia hospitalización Dashboard',
    description: 'Dashboard de perfil Experiencia hospitalización',
    backgroundClassName: (filters) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI, filtersData: Record<string, any>) => {
        return [

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Porcentaje de Satisfacción General',
                size: [2, 2],
                indicator: 'exp_hosp_csat',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'exp_hosp_nps',
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: DEFAULT_COLORS,
                    useCurrent: 0
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: '¿Por qué seleccionó nuestro Hospital?',
                size: [3, 2],
                indicator: 'exp_hosp_motivo_eleccion',
                extraConfigs: {
                    decimals: 0
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                key: 'exp-hosp-porc-env', 
                name: 'gaugeGenericByStatus',
                title: 'Porcentaje de respuestas',
                indicator: 'general-respuestas-gauge',
                mapper: msurPorcRespuestasMapper,
                tooltipFormatter: msurTooltipTotalRegistros,
                size: [1, 2],
                url: 'dashboard/status',
                extraIndicatorConfigs: {
                    keyExtract: ['resume'],
                    singleton: true
                },
                extras: {
                    useLcmApi: true,
                    workflowName: 'exp_hosp'
                },
                extraConfigs: {
                    showPercentage: true,
                }
            }),

            
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Gráfico de Satisfacción',
                size: [2, 2],
                indicator: 'exp_hosp_grafico_satisfaccion',//indicator_id: 13114
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Gráfico de Experiencia del Paciente',
                size: [2, 2],
                indicator: 'exp_hosp_grafico_exp_paciente',//indicator_id: 13115
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción por Tipo de Personal',
                key: 'bar-by-question-personal',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: formatLabelsObject(GROUP_LABELS_PERSONAL, {
                        maxWordsPerLine: 3,
                        breakChar: '\n',
                    }),
                    decimals: 0,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_PERSONAL).join(","),
                },
                size: [4, 2],
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción hacia Admisión',
                key: 'bar-by-question-admision',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_ADMISION,
                    decimals: 0,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_ADMISION).join(","),
                },
                size: [2, 2],
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción hacia Enfermería',
                key: 'bar-by-question-enfermeria',
                indicator: 'MERGE',
                extraConfigs: {
                     groupLabels: formatLabelsObject(GROUP_LABELS_ENFERMERIA, {
                        maxWordsPerLine: 3,
                        breakChar: '\n',
                    }),
                    decimals: 0,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_ENFERMERIA).join(","),
                },
                size: [2, 2],
            }),
            
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: 'Uso de lenguaje accesible',
                size: [4, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'exp_hosp_enfermeria_informacion'
            }),  

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción hacia el Personal Médico',
                key: 'bar-by-question-personal-medico',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_PERSONAL_MEDICO,
                    decimals: 0,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_PERSONAL_MEDICO).join(","),
                },
                size: [4, 2],
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción hacia Nutrición',
                key: 'bar-by-question-nutricion',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: formatLabelsObject(GROUP_LABELS_NUTRICION, {
                        maxWordsPerLine: 3,
                        breakChar: '\n',
                    }),
                    decimals: 0,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_NUTRICION).join(","),
                },
                size: [2, 2],
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción hacia Camilleros',
                key: 'bar-by-question-camillero',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_CAMILLERO,
                    decimals: 0,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_CAMILLERO).join(","),
                },
                size: [2, 2],
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción hacia Servicios a Pacientes y Familiares',
                key: 'bar-by-question-pacientes-familiares',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_PACIENTES_Y_FAMILIARES,
                    decimals: 0,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_PACIENTES_Y_FAMILIARES).join(","),
                },
                size: [4, 2],
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción hacia las Instalaciones',
                key: 'bar-by-question-instalaciones',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_INSTALACIONES,
                    decimals: 0,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_INSTALACIONES).join(","),
                },
                size: [2, 2],
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                title: '% Satisfacción hacia la Limpieza',
                key: 'bar-by-question-limpieza',
                indicator: 'MERGE',
                extraConfigs: {
                    groupLabels: GROUP_LABELS_LIMPIEZA,
                    decimals: 0,
                },
                extras: {
                    groupNameFormat: 'name',
                    formula: 'nps-5',
                    indicators: Object.keys(GROUP_LABELS_LIMPIEZA).join(","),
                },
                size: [2, 2],
            }),


            {
                title: 'Claridad de información y la atención',
                type: 'label',
                size: [4, 1],
                //config: { color: '#B7AADC' },
            },

            //1
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Información derechos del paciente',
                size: [1, 2],
                indicator: 'exp_hosp_ingreso_claridad_educacion',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            //2
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Explicaron claramente sobre su padecimiento',
                size: [1, 2],
                indicator: 'exp_hosp_ingreso_claridad_padecimiento',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            //3
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Información y explicación de consentimiento informado',
                size: [1, 2],
                indicator: 'exp_hosp_ingreso_consentimiento',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            //4
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Informaron usando un lenguaje fácil',
                size: [1, 2],
                indicator: 'exp_hosp_claridad_informacion',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            //5
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Personal ofreció privacidad, seguridad y respeto',
                size: [1, 2],
                indicator: 'exp_hosp_inf_y_ate_privacidad',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),


            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'El médico informo sobre el estado de salud',
                size: [1, 2],
                indicator: 'exp_hosp_inf_y_ate_dedicacion',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),



                        getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Aclaración de inquietudes',
                size: [1, 2],
                indicator: 'exp_hosp_inf_y_ate_inquietudes',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),


            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Atención del dolor',
                size: [1, 2],
                indicator: 'exp_hosp_inf_y_ate_atencion_adecuada',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),


            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Inclusión del paciente en el padecimiento',
                size: [1, 2],
                indicator: 'exp_hosp_inf_y_ate_consideraciones',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),


            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: 'Personal de salud usó lenguaje accesible',
                size: [1, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'exp_hosp_enfermeria_informacion'
            }),      
            

            {
                title: 'Aseguradora',
                type: 'label',
                size: [4, 1],
                //config: { color: '#B7AADC' },
            },
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: '¿Usted ingresó con alguna aseguradora?',
                size: [1, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'exp_hosp_seguros_aseguradora'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: '¿Su egreso fue ágil?',
                size: [1, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'exp_hosp_seguros_egreso'
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Personal de compañía de seguros lo orientó en los procedimientos',
                size: [1, 2],
                indicator: 'exp_hosp_seguros_personal',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Rapidez en la tramitación de su compañía de seguros fue satisfactoria',
                size: [1, 2],
                indicator: 'exp_hosp_seguros_tramitacion',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),


            {
                title: 'Experiencia y Recomendaciones',
                type: 'label',
                size: [4, 1],
                //config: { color: '#B7AADC' },
            },

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'lastComments',
                size: [4, 2],
                indicator: 'COMMENTS',
                extraConfigs: {
                    maxCommentSize: 120
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'textAnalysis',
                title: 'Clasificación Mande',
                size: [4, 3],
                indicator: 'SENTIMENT'
            }),
        ]
    },
} as DasboardConfig
